export default __webpack_public_path__ + "static/media/PodLogoSmall.2af60c40.svg";